import styled, { css } from 'styled-components'
// icons
import LinkIconOrigin from '@mui/icons-material/Link'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { MatrixFieldContainer } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/MatrixField/views'
// themes
import colors from 'themes/colors'

export const RowWrapper = styled.div<{ $mb: number; $showLinkIcon: boolean; }>`
  position: relative;
  display: flex;
  gap: 4px;
  transition: margin-bottom 150ms ease;
  margin-bottom: ${({ $mb }) => `${$mb}px`};

  > div:first-child {
    min-width: 164px;
    width: 100%;
  }

  ${ButtonsWrapper} {
    display: flex;
    top: -20px;
    right: 0;
    z-index: 9;
  }

  @media (hover: hover) and (pointer: fine) {
    ${ButtonsWrapper} {
      display: none;
    }

    &:hover {
      ${ButtonsWrapper} {
        display: flex;
      }
    }
  }

  ${({ $showLinkIcon }) =>
    $showLinkIcon &&
    css`
      ${MatrixFieldContainer} {
        min-height: 46px;
      }

      > div:first-child {
        padding-top: 14px;
      }
    `}
`

export const LinkIcon = styled(LinkIconOrigin)`
  position: absolute;
  top: -2px;
  left: -3px;
  height: 18px;

  path {
    fill: ${colors.gray280};
  }
`

export const OuterWrapper = styled.div<{ $bg: string }>`
  background-color: ${({ $bg }) => $bg ?? 'transparent'};
`
